import React, { useEffect, useState, Fragment } from 'react';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import { LoadingMaterialTable } from "../../../Common/table";
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
//import LockResetIcon from '@material-ui/icons/LockReset';

export const CommonPackageCreationListing = ({ commonPackageData, handleClick }) => {
    const [packageCreation, setPackageCreation] = useState([]);

    useEffect(() => {
        trackPromise(
            setPackageCreationData()
        )
    }, [commonPackageData]);

    async function setPackageCreationData() {
        await setPackageCreation(commonPackageData);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <LoadingMaterialTable

                title=""
                columns={[
                    {
                        title: "Collection Point", field: "collectionPointName",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            whiteSpace: 'nowrap',
                            textAlign: "center"

                        }
                    },
                    {
                        title: "Package Code", field: "packageCode",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            whiteSpace: 'nowrap',
                            textAlign: "center"

                        }
                    },
                    {
                        title: "Package Name", field: "packageName",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Status ", field: "isActive",
                        render: (data) => (
                            (data.isActive === true ? "Active" : "Inactive")
                        ),
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Card Number ", field: "cardNumber",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "User Name ", field: "userName",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Edit",
                        render: (data) => (
                            <BorderColorTwoToneIcon
                                onClick={() => handleClick(data)}
                                style={{ cursor: "pointer" }}
                            >
                                {" "}
                            </BorderColorTwoToneIcon>
                        ),
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    }
                ]}
                data={commonPackageData}

            />
        </Fragment>
    )

}